var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import React from 'react';
import { space, typography, layout, systemSxFromProps, } from '@revdotcom/vaporwave-system';
import { useCheckbox } from '@react-aria/checkbox';
import { useToggleState } from '@react-stately/toggle';
import { getCheckboxLabelSx, checkboxInputSx, } from '@revdotcom/vaporwave-sx';
import { forwardCommonProps } from '../../Helpers/CommonProps';
import { VisuallyHidden } from '@react-aria/visually-hidden';
import { useFocusRing } from '@react-aria/focus';
import { usePress } from '@react-aria/interactions';
import { mergeProps } from '@react-aria/utils';
import { InternalCheckbox } from '../Internal/InternalCheckbox';
var VaporwaveCheckbox = function (_a, ref) {
    var _b = _a.variant, variant = _b === void 0 ? 'normal' : _b, _c = _a.sizeVariant, sizeVariant = _c === void 0 ? 'small' : _c, onChangeHandler = _a.onChangeHandler, className = _a.className, _d = _a.fontSize, fontSize = _d === void 0 ? 1 : _d, props = __rest(_a, ["variant", "sizeVariant", "onChangeHandler", "className", "fontSize"]);
    var children = props.children;
    var state = useToggleState(props);
    var _e = React.useState(false), isHovered = _e[0], setIsHovered = _e[1];
    var _f = usePress({
        isDisabled: props.isDisabled,
    }), isPressed = _f.isPressed, pressProps = _f.pressProps;
    var fallbackRef = React.useRef(null);
    var DOMRef = ref !== null && ref !== void 0 ? ref : fallbackRef;
    var inputProps = useCheckbox(props, state, DOMRef).inputProps;
    // combine react-aria onChange and direct onChangeHandler, if at least one is provided
    var onChange = inputProps.onChange, restInputProps = __rest(inputProps, ["onChange"]);
    var onInputChange = onChangeHandler
        ? function (e) {
            onChange && onChange(e);
            onChangeHandler(e);
        }
        : onChange;
    var _g = useFocusRing(), isFocusVisible = _g.isFocusVisible, focusProps = _g.focusProps;
    var isSelected = state.isSelected && !props.isIndeterminate;
    return (_jsxs("label", __assign({ className: className, sx: __assign(__assign(__assign({}, getCheckboxLabelSx(variant, props.isDisabled, state.isSelected)), systemSxFromProps(props, __spreadArray(__spreadArray(__spreadArray([], space, true), typography, true), layout, true))), { fontSize: fontSize }), onMouseEnter: function () { return setIsHovered(true); }, onMouseLeave: function () { return setIsHovered(false); } }, pressProps, { children: [_jsx(VisuallyHidden, { children: _jsx("input", __assign({}, mergeProps(restInputProps, focusProps), forwardCommonProps(props), { onChange: onInputChange, sx: checkboxInputSx, ref: DOMRef })) }), _jsx(InternalCheckbox, { isDisabled: props.isDisabled, isIndeterminate: props.isIndeterminate, isSelected: isSelected, isHovered: isHovered, isPressed: isPressed, isFocusVisible: isFocusVisible, sizeVariant: sizeVariant }), children] })));
};
/**
 * Renders a checkbox with the `children` as a label.
 *
 * The vaporwave Checkbox component can be styled using the styled-system margin, font-weight, font-size, width,
 * and display props.
 *
 * If no children are used for the checkbox, you MUST define the label for the checkbox using the `aria-label` or
 * `aria-labelledby` props.
 */
export var Checkbox = React.forwardRef(VaporwaveCheckbox);
